// This lives in a NEUTRAL (non-`'use client'`) module on purpose: the desktop
// row skeleton and the route-level `loading.tsx` are SERVER-rendered, so they
// import this constant directly. A value exported from a `'use client'` module
// is replaced by a client-reference proxy when imported into a Server Component
// — stringifying that proxy into a className yields garbage and the grid
// collapses to a single column. Keeping the string here makes it a plain value
// usable from both server and client.
const ROW_GRID_WITHOUT_VOTES_CLASS =
  'grid-cols-[minmax(0,2.5fr)_minmax(0,1.5fr)_minmax(0,0.75fr)_minmax(0,0.75fr)_minmax(0,1fr)_minmax(0,1.4fr)] gap-8 items-center' as const;

export function getProposalFeedGridClass(): string {
  return ROW_GRID_WITHOUT_VOTES_CLASS;
}
